import * as ActionTypes from '../Actions/ApplicationActions';
import * as UserActionTypes from '../Actions/UserActions';

export const application = (
  state = {
    creatorApplication: {},
    brandApplication: {}
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.UPDATE_CREATOR_APPLICATION: {
      return {
        ...state,
        creatorApplication: {
          ...state.creatorApplication,
          ...action.updates
        }
      };
    }

    case ActionTypes.CREATOR_APPLICATION_SUCCESS: {
      return {
        ...state,
        creatorApplication: {
          ...state.creatorApplication,
          waitlistObject: action.data
        }
      };
    }

    case ActionTypes.CREATOR_APPLICATION_FAILURE: {
      window.ALERT.error(action.error || 'There was an error submitting your application. Please review your inputted fields and retry.');
      return state;
    }

    case UserActionTypes.CONNECT_WAITLIST_INSTAGRAM_ACCOUNT_SUCCESS: {
      window.ALERT.success('Instagram account connected successfully');
      return {
        ...state,
        creatorApplication: {
          ...state.creatorApplication,
          instagramAccountConnected: true,
          instagramAccount: action.account
        }
      };
    }

    case UserActionTypes.CONNECT_WAITLIST_YOUTUBE_ACCOUNT_SUCCESS: {
      window.ALERT.success('Youtube account connected successfully');
      return {
        ...state,
        creatorApplication: {
          ...state.creatorApplication,
          youtubeAccountConnected: true,
          youtubeAccount: action.account
        }
      };
    }

    case UserActionTypes.CONNECT_WAITLIST_TIKTOK_ACCOUNT_SUCCESS: {
      window.ALERT.success('Tiktok account connected successfully');
      return {
        ...state,
        creatorApplication: {
          ...state.creatorApplication,
          tiktokAccountConnected: true,
          tiktokAccount: action.account
        }
      };
    }

    case UserActionTypes.LOGOUT_USER_SUCCESS:
    case ActionTypes.CLEAR_CREATOR_APPLICATION: {
      return {
        ...state,
        creatorApplication: {}
      };
    }

    default:
      return state;
  }
};
